import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import resultDeclarationapi from '../api/resultDeclaration';
import loginapi from '../api/login';

const Course = ({ course,handleStateChange ,accessToken,setAccessToken,setRefreshFailed}) => {
  const navigate = useNavigate();

const [isAppLoaded,setIsAppLoaded]=useState(true);
const [isOpen,setIsOpen]=useState('no');

  const toggleStatus=async ()=>{
    //setIsAppLoaded(false);
   
 try{       
        setIsAppLoaded(false);
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await resultDeclarationapi.post('/updateConvocationState',{isOpen,no:course.convocation_no},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
       // alert(response.data.rv.isOpen);
      setIsOpen((response.data.rv.isOpen));
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await resultDeclarationapi.post('/updateConvocationState',{isOpen,no:course.convocation_no},{headers:{'Authorization':`Bearer ${nat}`}});                       
                         setIsOpen((response.data.rv.isOpen));
                        
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }

      }

useEffect(()=>{
   setIsOpen(course.isOpen);
  },[]);
  return (
    <div      
      className="w-full  rounded-xl px-4 py-2 flex flex-col justify-center transition-shadow duration-300 
          bg-transparent text-gray-800 "
      >
      <p className="w-full text-xs text-center font-semibold mb-2">CONVO # {course.convocation_no}</p>
      
      {/* Semester-wise Cards */}
     <div
          
            className={
              `w-24 h-24 bg-white cursor-pointer shadow-md rounded-lg flex flex-col items-center justify-center text-gray-800 border border-gray-300
              ${
                isOpen === "yes"
                  ? "bg-gradient-to-r from-green-300 to-green-200 hover:from-green-600 hover:to-green-400 text-black"
                  : "bg-gradient-to-r from-pink-300 to-pink-600 hover:from-pink-500 hover:to-pink-700 text-white"
              }
              `
            }
          
          >
           

<div className="flex flex-col items-center justify-center space-x-2 p-1 rounded-md w-[98%] max-w-[400px] mt-1">
        <input
          type="checkbox"
          id="declaredCheckbox"
          checked={isOpen === "yes"}
          onChange={() => toggleStatus()}
          className="w-7 h-7 accent-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-offset-2 cursor-pointer"
        />
        {isAppLoaded  && <label
          htmlFor="declaredCheckbox"
          className="text-xs text-gray-700 cursor-pointer transition-colors duration-200 hover:text-blue-600 mt-1"
        >
         {isOpen === "yes" ? "OPEN" : "CLOSED"}
        </label>}
        {!isAppLoaded && <label
          htmlFor="declaredCheckbox"
          className="text-xs text-gray-700 cursor-pointer transition-colors duration-200 hover:text-blue-600 mt-1"
        >
         {isOpen === "yes" ? "OPEN" : "CLOSED"}
        </label>}
          {!isAppLoaded  && <label
          htmlFor="declaredCheckbox"
          className="text-xs text-gray-700 cursor-pointer transition-colors duration-200 hover:text-blue-600 mt-1"
        >
         WAIT...
        </label>}
      </div>


          </div>
    </div>
  );
};

export default Course;
